const COLLECTION = '/collection'
const COLLECTION_SHOWS = `${COLLECTION}/shows`
const COLLECTION_MOVIES = `${COLLECTION}/movies`

export { COLLECTION, COLLECTION_SHOWS, COLLECTION_MOVIES }
